
import "./editPieceContributorElement.css";

import DeleteButton from "../../../../../components/deleteButton";
import TextFieldArtistSuggestions from "../../../../../components/textField/textFieldArtistSuggestions";
import TextFieldDropdown from "../../../../../components/textField/textFieldDropdown";
import contributorTypes from "../../../../../data/json/contributorTypes.json";
import { ContributorDTO } from "../../../../../openapi-generated-client";

interface EditPieceContributorElementProps {
    contributor: ContributorDTO;
    setContributor: (v: ContributorDTO) => void;
    onDelete: () => void;
}

export type ArtistIdNamePair = {
    id: number;
    name: string;
}

export default function EditPieceContributorElement(props: EditPieceContributorElementProps) {

    var artistBio: ArtistIdNamePair = {
        id: props.contributor.artistId ?? -1,
        name: props.contributor.name ?? ""
    }

    return <div className="contributor">
        <TextFieldArtistSuggestions setArtist={(id: number, v: string) => {
            console.log("setting artist", id, v);
            props.setContributor({ ...props.contributor, name: v, artistId: id });

        }}  artist={artistBio} placeholder="Enter name" label="Name" onChange={(v: string) => {
            props.setContributor({ ...props.contributor, name: v, artistId: -1 });
        } } value={props.contributor.name ?? ""}/>
        <TextFieldDropdown title="Select a contributor type" label="Type" options={contributorTypes} setActive={(v: string) => {

            props.setContributor({ ...props.contributor, type: v });
        }} active={props.contributor.type ?? ""}/>
        <DeleteButton onDelete={props.onDelete}/>
    </div>
}